import { createAsyncThunk } from '@reduxjs/toolkit'
import { app } from 'app/providers/FirebaseProvider/ui/FirebaseProvider'
import { getAuth } from 'firebase/auth'
import { backendForFirebaseUser } from 'shared/api/backendForFirebaseUser'
import { loadLegacyFirestore } from 'shared/firebase/loadLegacyFirebase'

export const fetchCollectionData = createAsyncThunk(
    'collection/fetchCollectionData',
    async () => {
        const backend = backendForFirebaseUser(getAuth(app).currentUser)
        if (backend) {
            const result = await backend.getCollections()
            return result.collections
        }

        const { collection, db, getDocs } = await loadLegacyFirestore()
        const querySnapshot = await getDocs(collection(db, 'collections'))
        return querySnapshot.docs
            .map((document) => ({ ...document.data() }))
            .sort((a, b) => a.id - b.id)
    }
)
